// extracted by mini-css-extract-plugin
module.exports = {"Container":"AllocatedProjectsList_Container__1qyrQ"};